<template>
    <div class="col-lg-12">
        <div style="align-items: center;" class="card card-body">
            Carregando dados...
        </div>
    </div>
</template>